import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Module::TaskRequirements @requirements={{@record.requirements}} />")